// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import "@babel/polyfill";
// import '@babel/polyfill'
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'
import VueCordova from 'vue-cordova'
import VueHead from 'vue-head'
import App from './App'
import router from './router'
import {mapState, mapActions} from 'vuex'
// import VueTouch from 'vue-touch'
import * as VueGoogleMaps from 'vue2-google-maps'
import Vue2TouchEvents from 'vue2-touch-events'

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCMgNtGou7gYxcLtnGQapCBjxeGd4Di7AM',
        libraries: 'places', // This is required if you use the Autocomplete plugin
        // OR: libraries: 'places,drawing'
        // OR: libraries: 'places,drawing,visualization'
        // (as you require)

        //// If you want to set the version, you can do so:
        // v: '3.26',
    },

    //// If you intend to programmatically custom event listener code
    //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
    //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
    //// you might need to turn this on.
    // autobindAllEvents: false,

    //// If you want to manually install components, e.g.
    //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
    //// Vue.component('GmapMarker', GmapMarker)
    //// then disable the following:
    // installComponents: true,
})

require('./css/app.css');
require('../variants/' + BUILD_VARIANT + '/app.css');

Vue.use(Vuetify)
// Vue.use(VueTouch)
Vue.config.productionTip = false
Vue.use(VueCordova)
Vue.use(VueHead)
Vue.use(Vue2TouchEvents)

import VueLoading from 'vue-full-loading'

if (window.location.protocol === 'file:' || window.location.port === '3000') {
    var cordovaScript = document.createElement('script')
    cordovaScript.setAttribute('type', 'text/javascript')
    cordovaScript.setAttribute('src', 'cordova.js')
    document.body.appendChild(cordovaScript)
}

import SymptomCheckerStep1 from '@/components/SymptomChecker/Step1'
import SymptomCheckerStep2 from '@/components/SymptomChecker/Step2'
import SymptomCheckerStep3 from '@/components/SymptomChecker/Step3'
import SymptomCheckerStep4 from '@/components/SymptomChecker/Step4'
import SymptomCheckerStep5 from '@/components/SymptomChecker/Step5'
import SignUpPersonal from '@/components/SignUp/Personal'
import SignUpAddress from '@/components/SignUp/Address'
import SignUpMedical from '@/components/SignUp/Medical'
import SignUpPhysical from '@/components/SignUp/Physical'
import SignUpSocial from '@/components/SignUp/Social'
import SignUpTerms from '@/components/SignUp/Terms'

const Terms = () => import( '@/components/' + BUILD_VARIANT + '/Terms')
window.moment = require('moment');

Vue.component('vas-symptom-1', SymptomCheckerStep1)
Vue.component('vas-symptom-2', SymptomCheckerStep2)
Vue.component('vas-symptom-3', SymptomCheckerStep3)
Vue.component('vas-symptom-4', SymptomCheckerStep4)
Vue.component('vas-symptom-5', SymptomCheckerStep5)
Vue.component('vas-loading', VueLoading)

Vue.component('vas-signup-personal', SignUpPersonal)
Vue.component('vas-signup-address', SignUpAddress)
Vue.component('vas-signup-medical', SignUpMedical)
Vue.component('vas-signup-physical', SignUpPhysical)
Vue.component('vas-signup-social', SignUpSocial)
Vue.component('vas-signup-terms', SignUpTerms)
Vue.component('vas-terms', Terms)

import store from './state'

window.tokenSent = false;

window.Loading = {
    show(label) {
        EventBus.$emit('app-show-loading', label);
    },
    hide() {
        EventBus.$emit('app-hide-loading');
    }
}

window.Dialog = {
    show(label) {
        EventBus.$emit('app-show-alert', label);
    },
    hide() {
        EventBus.$emit('app-hide-alert');
    }
}

window.Snackbar = {
    show(label) {
        EventBus.$emit('app-show-snackbar', label);
    },
    hide() {
        EventBus.$emit('app-hide-snackbar');
    }
}

router.beforeEach(function (to, from, next) {
    next();
});

function start() {
    /* eslint-disable no-new */
    new Vue({
        el: '#app',
        router,
        store,
        template: '<App/>',
        components: {App},
        head: {
            meta: [
                {
                    name: 'viewport',
                    content: 'width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover'
                }
            ]
        },
        created() {
            document.body.classList.add("loaded");

            if (typeof this.auth.remember === 'undefined' || this.auth.remember === null || this.auth.remember === '' || this.auth.user === null) {
                this.$router.push("/");
            }
        },
        computed: {
            ...mapState(
                ['auth']
            )
        }
    })
}

window.$ = window.jQuery = require('jquery');
start();